/**
 * Step 7: Clinical Application
 */
import React, { useEffect } from 'react';
import { Form, Input, InputNumber, Select, Button } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';

const { TextArea } = Input;

interface Step7Props {
  data: any;
  onChange: (data: any) => void;
}

const Step7ClinicalApplication: React.FC<Step7Props> = ({ data, onChange }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(data);
  }, [data, form]);

  const handleValuesChange = (_: any, allValues: any) => {
    onChange(allValues);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onValuesChange={handleValuesChange}
      initialValues={{ ...data, dosing_interval_rules: data.dosing_interval_rules || [] }}
    >
      <Form.Item label="推荐剂量" name="recommended_dose_amount">
        <Input placeholder="例如: 10-20" />
      </Form.Item>

      <Form.Item label="剂量单位" name="recommended_dose_unit">
        <Select placeholder="选择单位">
          <Select.Option value="mg/kg">mg/kg</Select.Option>
          <Select.Option value="mg">mg</Select.Option>
          <Select.Option value="mg/kg/day">mg/kg/day</Select.Option>
        </Select>
      </Form.Item>

      <Form.Item label="给药途径" name="recommended_dose_route">
        <Select placeholder="选择给药途径">
          <Select.Option value="静脉滴注">静脉滴注</Select.Option>
          <Select.Option value="静脉推注">静脉推注</Select.Option>
          <Select.Option value="口服">口服</Select.Option>
        </Select>
      </Form.Item>

      <Form.Item label="输注时长 (分钟)" name="infusion_duration_min">
        <InputNumber min={1} style={{ width: '100%' }} placeholder="例如: 60" />
      </Form.Item>

      <Form.Item label="给药间隔规则">
        <Form.List name="dosing_interval_rules">
          {(fields, { add, remove }) => (
            <>
              {fields.map(field => (
                <div key={field.key} style={{ display: 'flex', marginBottom: 8 }}>
                  <Form.Item name={field.name} noStyle>
                    <Input placeholder="例如: 肾功能正常: q8h" style={{ flex: 1 }} />
                  </Form.Item>
                  <Button
                    type="link"
                    danger
                    icon={<MinusCircleOutlined />}
                    onClick={() => remove(field.name)}
                  />
                </div>
              ))}
              <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                添加规则
              </Button>
            </>
          )}
        </Form.List>
      </Form.Item>

      <Form.Item label="目标 AUC 范围">
        <Input.Group compact>
          <Form.Item name="target_auc_min" noStyle>
            <InputNumber placeholder="最小值" style={{ width: '30%' }} />
          </Form.Item>
          <Input style={{ width: '10%', textAlign: 'center', pointerEvents: 'none' }} placeholder="~" disabled />
          <Form.Item name="target_auc_max" noStyle>
            <InputNumber placeholder="最大值" style={{ width: '30%' }} />
          </Form.Item>
          <Form.Item name="target_auc_unit" noStyle>
            <Input placeholder="单位" style={{ width: '30%' }} />
          </Form.Item>
        </Input.Group>
      </Form.Item>

      <Form.Item label="目标峰浓度范围">
        <Input.Group compact>
          <Form.Item name="target_peak_min" noStyle>
            <InputNumber placeholder="最小值" style={{ width: '30%' }} />
          </Form.Item>
          <Input style={{ width: '10%', textAlign: 'center', pointerEvents: 'none' }} placeholder="~" disabled />
          <Form.Item name="target_peak_max" noStyle>
            <InputNumber placeholder="最大值" style={{ width: '30%' }} />
          </Form.Item>
          <Form.Item name="target_peak_unit" noStyle>
            <Input placeholder="单位" style={{ width: '30%' }} />
          </Form.Item>
        </Input.Group>
      </Form.Item>

      <Form.Item label="目标谷浓度范围">
        <Input.Group compact>
          <Form.Item name="target_trough_min" noStyle>
            <InputNumber placeholder="最小值" style={{ width: '30%' }} />
          </Form.Item>
          <Input style={{ width: '10%', textAlign: 'center', pointerEvents: 'none' }} placeholder="~" disabled />
          <Form.Item name="target_trough_max" noStyle>
            <InputNumber placeholder="最大值" style={{ width: '30%' }} />
          </Form.Item>
          <Form.Item name="target_trough_unit" noStyle>
            <Input placeholder="单位" style={{ width: '30%' }} />
          </Form.Item>
        </Input.Group>
      </Form.Item>

      <Form.Item label="TDM 建议" name="tdm_recommendation">
        <TextArea rows={3} placeholder="例如: 建议在第 3-4 剂后采血监测谷浓度" />
      </Form.Item>
    </Form>
  );
};

export default Step7ClinicalApplication;
